"use client"

import { getSiteUrl } from "@repo/shared"
import { getCookie } from "cookies-next"
import { useEffect, useState } from "react"

export function getMetrixLocale(): string {
  const locale = getCookie("locale")
  return typeof locale === "string" && locale.trim() ? locale : "en"
}

export function useMetrixLocale(): string {
  const [locale, setLocale] = useState("en")

  useEffect(() => {
    setLocale(getMetrixLocale())
  }, [])

  return locale
}

export function buildMetrixUrl(pathname: string, locale: string, searchParams: Record<string, string> = {}): string {
  const url = new URL(pathname, `${getSiteUrl("ai")}/`)
  url.searchParams.set("locale", locale || "en")

  for (const [key, value] of Object.entries(searchParams)) {
    url.searchParams.set(key, value)
  }

  return url.toString()
}
